import { initializeApp } from 'firebase/app'
import { getFirestore, collection, getDocs, doc, getDoc, where, query } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: 'AIzaSyCb0fPOBOr3_2cAEydqZ87dicAiFqX8aVE',
    authDomain: 'constructorafqp.firebaseapp.com',
    projectId: 'constructorafqp',
    storageBucket: 'constructorafqp.appspot.com',
    messagingSenderId: '417714906827',
    appId: '1:417714906827:web:5fbbda8453a145381c5d4e'
}

const firebaseApp = initializeApp(firebaseConfig)
const db = getFirestore(firebaseApp)

async function getProjects() {
    const projectsRef = collection(db, 'projects')
    const documentsSnapshot = await getDocs(projectsRef)
    const documents = documentsSnapshot.docs
    const docsData = documents.map((project) => ({ ...project.data(), id: project.id }))
    return (docsData)
}
  
async function getProject(id) {
    const projectRef = doc(db, 'projects', id)
    const docSnapshot = await getDoc(projectRef)
      
    if (docSnapshot.exists()) {
        return { ...docSnapshot.data(), id: docSnapshot.id }
    } else {
        throw new Error('No pudimos encontrar ese proyecto');
    }
}
  
async function getProjectCategory(categoryId) {
    const projectsRef = collection(db, 'projects')
    const q = query(projectsRef, where('category', '==', categoryId))
    const documentsSnapshot = await getDocs(q)
    const documents = documentsSnapshot.docs
    const docsData = documents.map((project) => ({ ...project.data(), id: project.id }))
    if (docsData.length === 0) {
        throw new Error('No pudimos encontrar esa categoría')
    } else {
        return (docsData)
    }
}

export { getProjects, getProject, getProjectCategory }